import React, { useEffect } from "react";
import Direct from "../components/Direct";
import Error from "../components/Error";
const StoryBoardingDirect = ({
  stepArr,
  setStepArr,
  handleGenerateButtonClick,
  formData,
  setFormData,
  setFormDataError,
  sectionData,
  setSectionData,
  activeTab,
  updateSteps,
  generateSteps,
  regenerateImage,
  generateImage,
  handleStitch,
  formDataError,
  generatedImages,
  setGeneratedImages,
  validateDuration,
  errorMessage,
  setErrorMessage,
  makeLandingTrue,
  setShowDialog,
  generateDirectSteps,
  reviseDirectSteps,
  regenerateStep,
  generateDirectStoryboard,
  tailoredVisible,
  directVisible,
  ideateVisible,
  setIsStoryGenerated,
  isSidebarOpen
}) => {
  useEffect(() => {
    if (!stepArr) handleGenerateButtonClick();
  }, []);
  const handleSavingChange = (newStepArr) => {
    setStepArr(newStepArr);
  };
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  });
  return (
    <div className={`flex  h-full flex-1 w-full ${isSidebarOpen ? "hidden":"block"} md:block`}>
      <div className="flex justify-center w-full m-5">
        <div className="w-full h-full">
          {errorMessage && <Error errorMessage={errorMessage.message} />}
          <Direct
            setErrorMessage={setErrorMessage}
            errorMessage={errorMessage}
            steps={stepArr}
            formData={formData}
            setFormData={setFormData}
            setFormDataError={setFormDataError}
            sectionData={sectionData}
            setSectionData={setSectionData}
            handleSavingChange={handleSavingChange}
            updateSteps={updateSteps}
            generateSteps={generateSteps}
            regenerateImage={regenerateImage}
            generateImage={generateImage}
            handleStitch={handleStitch}
            formDataError={formDataError}
            generatedImagesGlobal={generatedImages}
            setGeneratedImagesGlobal={setGeneratedImages}
            validateDuration={validateDuration}
            makeLandingTrue={makeLandingTrue}
            setShowDialog={setShowDialog}
            generateDirectSteps={generateDirectSteps}
            reviseDirectSteps={reviseDirectSteps}
            regenerateStep={regenerateStep}
            generateDirectStoryboard={generateDirectStoryboard}
            tailoredVisible={tailoredVisible}
            directVisible={directVisible}
            ideateVisible={ideateVisible}
            setIsStoryGenerated={setIsStoryGenerated}
          />
        </div>
      </div>
    </div>
  );
};

export default StoryBoardingDirect;
